import { render, staticRenderFns } from "./America.vue?vue&type=template&id=70a60b45&scoped=true&"
import script from "./America.vue?vue&type=script&lang=js&"
export * from "./America.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a60b45",
  null
  
)

export default component.exports